module.exports = __webpack_public_path__ + "static/media/photo236.9d4285e0.jpg";